// 统一请求路径前缀在commmon/axios.js中修改
import { getRequest, postRequest, postRequestLogin, putRequest, putNoToken, getRequestWithNoToken } from '../assets/js/api';

// 家长学生基础信息新增
export const _basicInfo = (params) => {
  return postRequestLogin('/api-customer-c/psy_parent/basicInfo', params)
}

// 获取基础信息
export const _invokeList = (params) => {
  return getRequest('/api-common/dict-item/invoke/list', params)
}

// 获取基础信息
export const _invokeTree = (params) => {
  return getRequest('/api-common/district/invoke/tree', params)
}

// 根据家长手机号获取学生数据接口
export const _getStudentListByParentPhone = (params) => {
  return getRequest('/api-customer-c/psy_parent/getStudentListByParentPhone', params)
}

// 根据家长手机号获取家长数据接口
export const _getParentBasicInfoByParentPhone = (params) => {
  return getRequest('/api-customer-c/psy_parent/getParentBasicInfoByParentPhone', params)
}

// 根据家长手机号获取学生数据接口
export const _birthdayAndAgeAndSigns = (idCard, params) => {
  return getRequest(`/api-customer-c/psy_student/birthdayAndAgeAndSigns/${idCard}`, params)
}

// 查询学校列表信息接口
export const _schoolSearch = (params) => {
  return getRequest('/api-institution/school/search', params)
}

// 学生是否绑定他人弹窗接口
export const _matchParent = (data) => {
  return postRequest('/api-customer-c/psy_parent/bindPopup', data)
}

// 绑定验证接口
export const _bindParent = (data) => {
  return postRequest('/api-customer-c/psy_parent/bindVerification', data)
}